import React, { useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// import { GlobalContext } from '../contexts/GlobalContext';
import { QueryVSContext } from '../contexts/QueryVSContext';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import { Alert } from '@material-ui/lab';


export default function ValueSetDialogExpansion(props) {
    // const globals = useContext(GlobalContext)
    const vsContext = useContext(QueryVSContext)

    const expansionColumns = [
        { id: 'system', label: 'System', minWidth: 150 },
        { id: 'code', label: 'Code', minWidth: 170 },
        { id: 'display', label: 'Display', minWidth: 170 },
    ];

    const StyledTableCell = withStyles((theme) => ({
        head: {
            backgroundColor: '#383838',
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }))(TableCell);


    useEffect(() => {
        if (props) {
        }
    });

    const action = (
        <Button color="primary" variant="contained" onClick={handleExpansion} size="small">
            Expand ValueSet
        </Button>
    );

    function handleExpansion() {
        console.log('vsContext', vsContext);
        vsContext.doExpansion("@@");
        vsContext.setExpanded(true);
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function displayExpansion() {

        console.log(vsContext.expansionValueSet);

        if (vsContext.expansionValueSet.resourceType === "OperationOutcome") {
            return <Alert severity="error">ValueSet expansion has failed</Alert>
        }

        if (vsContext.expansionValueSet.resourceType === "ValueSet") {
            var expansionTotal = vsContext.expansionValueSet.expansion.contains.length;
            var expansionGrandTotal = (vsContext.expansionValueSet.expansion.total) ? vsContext.expansionValueSet.expansion.total : expansionTotal;

            if (expansionTotal === expansionGrandTotal) {
                return <Alert severity="success">Processing successful. Expansion has {expansionTotal} codes</Alert>
            } else {
                return <Alert severity="warning">Processing successful. First {numberWithCommas(expansionTotal)} codes of {numberWithCommas(expansionGrandTotal)} shown.</Alert>
            }
        }
    }

    function displayExpansionError() {

        var exp = vsContext.expansionValueSet;
        if (vsContext.expansionValueSet.resourceType === "OperationOutcome") {
            return (
                <Paper className="vsTable__operationOutcome">
                    <div className="vsDialogData">
                        <div className="vsDialogData__left">
                            {displayProperty('Reponse', exp.resourceType)}
                            {displayProperty('Severity', exp.issue[0].severity)}
                            {displayProperty('Diagnostics', exp.issue[0].diagnostics)}

                        </div>
                    </div>
                </Paper>
            )
        }
    }
    function displayString(x) {
        if (x !== undefined) {
            return x;
        } else {
            return <span className="nullItem">null</span>;
        }
    }

    function displayProperty(title, rawValue) {
        var value = '';

        switch (typeof rawValue) {
            case 'string':
                value = displayString(rawValue);
                break;
            // case 'boolean':
            //     value = displayBoolean(rawValue);
            //     break;
            case 'number':
                value = displayString(rawValue);
                break;
            case 'undefined':
                value = displayString(rawValue);
                break;
            default:
                console.log(typeof rawValue);
                value = 'XXX';
        }

        return (
            <div className="vsDialogData__itemContainer">
                <div className="vsDialogData__itemLabel">{title}</div>
                <div className="vsDialogData__itemValue">{value}</div>
            </div>
        );
    }
    function displayExpansionTable() {

        if (vsContext.expansionValueSet.resourceType === "ValueSet") {
            return (
                <TableContainer className="vsTable__expansionContainer">
                    <Table stickyHeader attribute="vsTable_tableHeader" size="small" aria-label="sticky table">
                        <TableHead attribute="vsTable_tableHeader">
                            <TableRow>
                                {expansionColumns.map((column) => (
                                    <StyledTableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </StyledTableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {vsContext.expansionValueSet.expansion.contains.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        <TableCell key={expansionColumns[0].id} align={expansionColumns[0].align}>
                                            {row[expansionColumns[0].id]}
                                        </TableCell>

                                        <TableCell key={expansionColumns[1].id} align={expansionColumns[1].align}>
                                            {row[expansionColumns[1].id]}
                                        </TableCell>

                                        <TableCell key={expansionColumns[2].id} align={expansionColumns[2].align}>
                                            {row[expansionColumns[2].id]}
                                        </TableCell>

                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )
        }
    }

    return (
        <div>
            {vsContext.expanded && displayExpansion()}
            {vsContext.expanded && displayExpansionTable()}
            {vsContext.expanded && displayExpansionError()}
            {!vsContext.expanded &&
                <SnackbarContent message={'ValueSet expansion has not been performed'} action={action} />
            }
        </div>
    );

}
